export function Util_compareObjDistances(a: any, b: any) {
    if (a.distance < b.distance) return -1
    if (a.distance > b.distance) return 1
    return 0
}

function toRad(value: number) {
    return value * (Math.PI / 180)
}

export function Util_calcDistance(lat1: number, lon1: number, lat2: number, lon2: number, precision: number): number {
    const R = 6371 // km
    const dLat = toRad(lat2 - lat1)
    const dLon = toRad(lon2 - lon1)

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(toRad(lat1)) * Math.cos(toRad(lat2))
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
    let d = R * c

    if (precision != null) {
        // Note: toFixed converts the result to a string
        d = Number(d.toFixed(precision))
    }

    return d
}
